import React from 'react';
import PropTypes from 'prop-types'
import clsx from 'clsx';
import {
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.grid.borderRadius,
    position: 'relative'
  }
}));

function MosaicPanel({ className, children }) {
  const classes = useStyles();

  return (
    <div className={clsx(className, classes.root)}>
      {children}
    </div>
  );
}

MosaicPanel.propTypes = {
  clasName: PropTypes.string,
  loading: PropTypes.bool,
  children: PropTypes.any
}


MosaicPanel.defaultProps = {
  loading: false
}


export default MosaicPanel;

